import { useEffect, useState } from "react";
import { coverFor } from "./covers";

/** A game's cover URL once known; null while loading or when it has none. */
export function useCover(name: string | null) {
  const [found, setFound] = useState<{ name: string; src: string | null } | null>(null);
  useEffect(() => {
    if (!name) return;
    let live = true;
    coverFor(name).then((url) => live && setFound({ name, src: url }));
    return () => {
      live = false;
    };
  }, [name]);
  return found?.name === name ? found.src : null;
}
